export default __webpack_public_path__ + "static/media/address.e4a6da94.png";